import { render, staticRenderFns } from "./pre-remind-setting.vue?vue&type=template&id=18c49111&"
import script from "./pre-remind-setting.vue?vue&type=script&lang=ts&"
export * from "./pre-remind-setting.vue?vue&type=script&lang=ts&"
import style0 from "./pre-remind-setting.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports